import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "genie_cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);
  if (!show) return null;
  function accept() {
    localStorage.setItem(KEY, "1");
    setShow(false);
  }
  return (
    <div
      data-testid="cookie-consent"
      className="fixed inset-x-0 bottom-0 z-40 border-t-2 border-ink bg-paper px-5 py-4 sm:px-8"
    >
      <div className="mx-auto flex max-w-desk flex-col items-start gap-3 pr-16 sm:flex-row sm:items-center sm:justify-between sm:pr-20">
        <p className="text-sm leading-relaxed text-muted">
          We use essential cookies and local storage to run this site (for example, to keep your
          chat session active). We don&apos;t use advertising or cross-site tracking cookies. Learn
          more in our{" "}
          <Link to="/privacy" className="text-accent hover:underline">Privacy Policy</Link>.
        </p>
        <button
          onClick={accept}
          data-testid="cookie-accept"
          className="shrink-0 bg-accent px-6 py-2.5 font-mono text-[10px] uppercase tracking-widest text-paper transition-opacity hover:opacity-90"
        >
          Accept
        </button>
      </div>
    </div>
  );
}
